import { HttpClient } from '@angular/common/http';
import { LoganApiConfig } from '../models/services.model';
import { LoganApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoganStatusService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {};


  public loganStatus(): Observable<any> {
    return this.http.get<any>(`${this.apiServerUrl}/api/v1/loganStatus`);
  }
}
